import { render, staticRenderFns } from "./NewCustomerFormTemplate.vue?vue&type=template&id=0a2c8470&"
import script from "./NewCustomerFormTemplate.vue?vue&type=script&lang=js&"
export * from "./NewCustomerFormTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports